import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiRestService } from "../../_service/api-rest.service";
import { ApiRestService as PersonaleApiRestService } from "../../../Admin/_service/api-rest.service";
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { EditService, EditSettingsModel } from '@syncfusion/ej2-angular-gantt';
import { TaskService } from '../../_service/task.service';


@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-attivita-gantt',
  providers: [EditService],
  template: `
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-t-0 p-b-0">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <label for="inizio" class="control-label col-form-label">Inizio</label>
                  <input id="inizio" required [(ngModel)]="filtri.inizio" (ngModelChange)="refresh()" class="form-control" type="date">
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <label for="fine" class="control-label col-form-label">Fine</label>
                  <input id="fine" required [(ngModel)]="filtri.fine" (ngModelChange)="refresh()" class="form-control" type="date">
                </div>
              </div>
              <div class="col-lg-2">
              <div class="form-group">
                <label class="control-label col-form-label">{{'Scadenza.cliente' | translate}}</label>
                  <ng-multiselect-dropdown [settings]="clientidropdownSettings" [placeholder]="'Scadenza.cliente' | translate" id="cliente" [data]="clienti"
                                          [(ngModel)]="clientiselezionati" (onFilterChange)="filtroCliente($event)" (ngModelChange)="refresh()" >
                  </ng-multiselect-dropdown>
              </div>
            </div>
             <div class="col-lg-2">
              <div class="form-group">
                <label class="control-label col-form-label">{{'Task' | translate}}</label>
                  <ng-multiselect-dropdown [settings]="taskDropdownSettings" [placeholder]="'Task' | translate" id="cliente" [data]="Tasks"
                                          [(ngModel)]="TaskSelezionati" (ngModelChange)="refreshGantt()">
                  </ng-multiselect-dropdown>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div >
      <ejs-gantt
        #gantt
        id="ganttDefault" height="430px"
        *ngIf="Tasks.length && show"
        [dataSource]="GetData()"
        [includeWeekend]='true'
        [taskFields]="taskSettings"
        [editSettings]="editSettings"
        [allowUnscheduledTasks]="true"
        [projectStartDate]="filtri.inizio"
        [projectEndDate]="filtri.fine"
        (onTaskbarClick)="onTaskbarClick($event)"
        [allowResizing]="true"
        [columns]="columns"
      >
      </ejs-gantt>
    </div> 
  `,
})
export class AttivitaGanttComponent implements AfterViewInit {
  @ViewChild('gantt') ganttContainer;
  @Input() Project_ID: number = undefined;
  private type: any;
  show: boolean = true;
  Tasks: any[] = [];
  TaskSelezionati: any[] = [];
  filtri: any = { inizio: this.datePipe.transform(new Date(new Date().getFullYear(), 0, 1, 0, 0), 'yyyy-MM-dd'), fine: this.datePipe.transform(new Date(new Date().getFullYear() + 1, 0, 0, 23, 59), 'yyyy-MM-dd') };
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  
  taskDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'like',
    searchPlaceholderText: "Cerca",
    allowSearchFilter: true,
    allowRemoteDataSearch: false,
  };
  clientiselezionati: any;
  clienti: any;
  columns: any[] = [
    {
      field: 'Progressivo',
      headerText: 'ID',
      width: '120',
      textAlign: 'Left',
      allowResizing: true  // Abilita il ridimensionamento per questa colonna
    },
    {
      field: 'TaskName',
      headerText: 'Task',
      width: '250',
      textAlign: 'Left',
      allowResizing: true  // Abilita il ridimensionamento per questa colonna
    },
    {
      field: 'Durata',
      headerText: 'Durata',
      width: '125',
      textAlign: 'Left',
      allowResizing: false,  // Abilita il ridimensionamento per questa colonna
      allowEditing:false,
    },
  ]
  public editSettings: EditSettingsModel = {
    allowAdding: false,
    allowEditing: true,
    allowDeleting: false,
    allowTaskbarEditing: false,  // Disabilita l'aggiornamento automatico della durata
    mode: 'Dialog',
    newRowPosition: 'Top',
    showDeleteConfirmDialog: true
  };
  public taskSettings?: object = {
    id: 'TaskID',
    taskId: 'TaskID',
    name: 'TaskName',
    startDate: 'StartDate',
    endDate: 'EndDate',
    duration: 'Duration',
    progress: 'Progress',
    dependency: 'Predecessor',
    child: 'subtasks',
    durationUnit:'durationUnit'
  };
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private apiRestService: ApiRestService,
    private datePipe: DatePipe,
    private personaleApiRestService: PersonaleApiRestService,
    private TaskService: TaskService
  ) { }
  filtroCliente(event: string) {
    if (event.length >= 3)
      this.personaleApiRestService.getListaAziende(new RicercaPaginazione(event, 0, 1)).subscribe(data => this.clienti = data?.data);
  }
  refreshGantt() {
    this.show = false;
    setTimeout(() => this.show = true, 100);
  }

  ngAfterViewInit() {
    var now = new Date();
    this.filtri.inizio = this.datePipe.transform(new Date(now.getFullYear(), 0, 1, 0, 0), 'yyyy-MM-dd');
    this.filtri.fine = this.datePipe.transform(new Date(now.getFullYear() + 1, 0, 0, 23, 59), 'yyyy-MM-dd');
    this.route.params.subscribe(data => {
      this.type = data['progetto'];
      if (this.type)
        this.filtri.progetto = parseInt(this.type);
      this.refresh();
    })
    this.refresh();
  }

  onTaskbarClick(item) {
    console.log(item);
    var task = item.data.taskData;
    this.TaskService.OpenFromTask(task, () => {
      this.refresh();
    })
  }

  refresh() {
    this.refreshData();
  }
  GetData() { 
    return this.TaskSelezionati.length ? this.TaskSelezionati : this.Tasks;
  }
  refreshData() {
    this.apiRestService.getGanttAttivitaTecnici(this.filtri.inizio, this.filtri.fine, [], this.clientiselezionati?.map(x => x.id)).subscribe(data => {
      var Parents = data.data.map(task => {
        // task.end_date = task.children.reduce((max, child) => {
        //   return new Date(child.end_date) > new Date(max) ? child.end_date : max;
        // }, task.end_date);
        return task;
      })
      this.Tasks = Parents.map((task) => this.mapTask(task))
      console.log("Tasks: ", this.Tasks) 
    });
  }


  mapTask(task) {
    task.subtasks = task.children.map(x => this.mapTask(x));
    task.StartDate = new Date(task.start_date);
    task.EndDate = new Date(task.end_date);
    task.TaskID = task.id ?? 0;
    task.TaskName = task.text;
    task.Progressivo = task.parent ? '' : task.id?.toString();
    task.like = `${task.id} - ${task.text}`;
    task.Durata = `${this.getOre(task).toFixed(2) ?? 0} Ore`
    task.durationUnit = "hour";
    return task;
  }

  getOre(task) {
    switch (task.type) {
      case 'R':
        return task.tempi.reduce((total, x) => total + x.durata, 0);
      case 'W' :
        return this.calcolaOreLavorative(task.StartDate, task.EndDate);
    }
    return 0;
  }

  calcolaOreLavorative(
    startDate: Date,
    endDate: Date,
    orarioInizio: string = '09:00',
    orarioFine: string = '18:00',
    intervalloPranzoInizio: string = '13:00',
    intervalloPranzoFine: string = '14:00',
    giorniLavorativi: boolean[] = [false, true, true, true, true, true, false] // Lunedì-Venerdì lavorativi
  ): number {
  const msInHour = 1000 * 60 * 60;

  let totalHours = 0;
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const currentDay = currentDate.getDay();

    if (giorniLavorativi[currentDay]) {
      // Costruisci gli orari della giornata lavorativa
      let inizioLavoro = new Date(currentDate);
      inizioLavoro.setHours(parseInt(orarioInizio.split(':')[0]), parseInt(orarioInizio.split(':')[1]), 0, 0);

      let fineLavoro = new Date(currentDate);
      fineLavoro.setHours(parseInt(orarioFine.split(':')[0]), parseInt(orarioFine.split(':')[1]), 0, 0);

      let inizioPranzo = new Date(currentDate);
      inizioPranzo.setHours(parseInt(intervalloPranzoInizio.split(':')[0]), parseInt(intervalloPranzoInizio.split(':')[1]), 0, 0);

      let finePranzo = new Date(currentDate);
      finePranzo.setHours(parseInt(intervalloPranzoFine.split(':')[0]), parseInt(intervalloPranzoFine.split(':')[1]), 0, 0);

      // Calcola la parte di giornata lavorativa da considerare
      let actualStart = currentDate < inizioLavoro ? inizioLavoro : currentDate;
      let actualEnd = endDate < fineLavoro ? endDate : fineLavoro;

      if (actualStart < actualEnd) {
        // Ore lavorate mattina
        if (actualStart < inizioPranzo) {
          let morningEnd = actualEnd < inizioPranzo ? actualEnd : inizioPranzo;
          totalHours += (morningEnd.getTime() - actualStart.getTime()) / msInHour;
        }

        // Ore lavorate pomeriggio
        if (actualEnd > finePranzo) {
          let afternoonStart = actualStart > finePranzo ? actualStart : finePranzo;
          totalHours += (actualEnd.getTime() - afternoonStart.getTime()) / msInHour;
        }
      }
    }

    // Vai al giorno successivo
    currentDate.setDate(currentDate.getDate() + 1);
    currentDate.setHours(0, 0, 0, 0); // Resetta l'ora per iniziare dalla mezzanotte
  }

  // Restituisci il risultato con 2 decimali
  return parseFloat(totalHours.toFixed(2));
}


}

